module.exports = __webpack_public_path__ + "static/logo2-eaacec224f6fba27a7a37d4c8fa446fe.png";